import { Sections } from "./Enums/Sections.enum";

export class FillerNavItem
{ 
    label: string; 
    icon: string; 
    link: number;
    section: Sections; 
    complete:boolean=false;
    rejected:boolean = false;
    message:boolean=false;
    Review :boolean=false;
    update: boolean = false;
};